<template>
  <VueperSlides
    autoplay
    class="no-shadow cities-carousel"
    :visible-slides="3"
    slide-multiple
    :gap="3"
    :slide-ratio="1 / 4"
    :dragging-distance="50"
    :breakpoints="breakpoints"
    :touchable="false"
  >
    <VueperSlide
      v-for="(city) in citiesList"
      :key="city.id"
      :image="city.image"
      :title="cityTitle(city.id)"
      :alt="city.keywords"
      @click.native="cityClicked(city.id)"
    />
  </VueperSlides>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides';
import getCountryFromIp from '@/components/CommonScripts/IPInfo';
import { cities, citiesForCarousel } from '@/data/cities';
import countries from '../../data/countries';
import '@/assets/css/custom-vueper-slide.css';

export default {
  name: 'CitiesCarousel',
  components: {
    VueperSlides,
    VueperSlide,
  },

  data() {
    return {
      citiesList: [],
      breakpoints:
        {
          600: {
            visibleSlides: 1,
            slideMultiple: 1,
            slideRatio: 2 / 3,
            arrows: true,
            bulletsOutside: true,
            touchable: true,
            pauseOnTouch: true,
          },
          1000: {
            visibleSlides: 2,
            slideMultiple: 2,
            slideRatio: 1 / 3,
            arrows: true,
            bulletsOutside: true,
            touchable: true,
          },
        },
    };
  },
  async created() {
    let citiesIds = '';
    const ipCountry = await getCountryFromIp();

    if (citiesForCarousel[ipCountry]) {
      citiesIds = citiesForCarousel[ipCountry];
    } else {
      citiesIds = citiesForCarousel.default;
    }

    citiesIds.forEach((cityId) => {
      const cityIndex = cities.findIndex((city) => city.id === cityId);
      const city = cities[cityIndex];

      const { id } = city;
      const { keywords } = city;
      try {
        const image = require(`../../assets/img/cities/${id}.jpg`);
        this.citiesList.push({
          id, image, keywords,
        });
      } catch (e) {
        // nada
      }
    });
  },
  methods: {
    cityTitle(cityId) {
      const cityIndex = cities.findIndex((city) => city.id === cityId);
      const city = cities[cityIndex];
      const countryIndex = countries.findIndex((country) => country.id === city.country);

      const title = `${countries[countryIndex].icon} | ${this.$t(`lang.cities.${cityId}`)}`;

      return title;
    },

    cityClicked(city) {
      this.$emit('selectedCity', city);
    },
  },

};
</script>

<style scoped>
</style>
